// extracted by mini-css-extract-plugin
export default {"wrapper":"M8X07r","headingContainer":"h4j4eY","imageContainer":"jK41UH","bowlImage":"za7aYa","comparison":"LAd8fT","ourFood":"Waq_6x","theirFood":"RRLCQ2","arrow":"y1QWuS"};